import ImpactShow from "../components/impact/Show";

export default [
  { name: 'Impact', path: '/impact', component: ImpactShow,  }
]